import {
  useAllLocationsDropdownLoading,
  useAllTagLocationsDropdownLoading,
} from "../../variables/selectedLocationDropdown";

const useGetAllLocationsDropdownLoading = () => {
  const allLocationsDropdownLoadingVariable = useAllLocationsDropdownLoading();

  const allTagLocationsDropdownLoadingVariable =
    useAllTagLocationsDropdownLoading();

  return {
    locationsDropdownLoading:
      allLocationsDropdownLoadingVariable ||
      allTagLocationsDropdownLoadingVariable,

    allLocationsDropdownLoadingVariable,
    allTagLocationsDropdownLoadingVariable,
  };
};

export default useGetAllLocationsDropdownLoading;
